import { render, staticRenderFns } from "./CouponRedeemConfirm.vue?vue&type=template&id=8ce8b3b6&"
import script from "./CouponRedeemConfirm.vue?vue&type=script&lang=js&"
export * from "./CouponRedeemConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CouponRedeemConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports